import { defineComponent as _defineComponent } from 'vue'
import FloatingActionButton from "@/components/buttons/FloatingActionButton.vue";

import AddressEdit from "@/components/AddressEdit.vue";

import {
  computed,
  onMounted,
  PropType,
  ref,
  unref,
  watch,
} from "vue";

import {
  useI18n,
} from "@/composables/useI18n";

import {
  firstNameLength,
  lastNameLength,
  mailLength,
  paycardNumberLength,
  phoneNumberLength,
} from "@/scripts/Common/constraints/constraints";

import {
  isBiggerOrEqualToMinLength,
  isRequired,
  isSmallerOrEqualToMaxLength,
  isValidEmail,
} from "@/scripts/Common/validators/defaultValidator";

import {
  copyObject,
} from "@/scripts/Common/HelperFunctions";

import type {
  User,
} from "@/components/users/scripts";

import {
  createOrUpdateUser,
  fetchUsers,
  selectUser,
  createEmptyUser,
  resetUserObject,
  userHasChanges,
  USER_ID_STORAGE_KEY,
} from "@/components/users/scripts";

import {
  httpMethod,
} from "@/scripts/Common/api";

import {
  getNumberItemFromStorage,
  saveItemToStorage,
} from "@/scripts/Common/componentStorage";


export default /*#__PURE__*/_defineComponent({
  __name: 'UserCoreData',
  props: {
  hasEditRights: {
    required: true,
    type: Boolean as PropType<boolean>,
  },
  startInCreationMode: {
    required: true,
    type: Boolean as PropType<boolean>
  }
},
  emits: [
  'onFetchError'
],
  setup(__props, { emit: emits }) {

const props = __props;

const {
  t,
} = useI18n();





const comboSelection = ref<User | undefined>();
const users = ref<User[]>([]);
const userForm = ref();

const selectedUserId = ref<number>(0);
const selectedUser = ref<User>(createEmptyUser());
const initialUserData = ref<User>(createEmptyUser());

const hasNoEditRights = !props.hasEditRights;
const isValid = ref<boolean>(true);
const addressValid = ref<boolean>(true);
const isCreationMode = ref<boolean>(false);
const panelExpander = ref([1]);

const canSave = computed(() => {
  return isValid.value
      && addressValid.value
      && userHasChanges(unref(initialUserData), unref(selectedUser));
});

const onHandleFetchError = ({error}: {
  error: any
}) => {
  emits('onFetchError', error)
};

const hasUsers = computed(() => {
  return users.value && users.value.length > 0;
})

const comboboxIsActive = computed(() => {
  if (!hasUsers.value) return false;

  return !isCreationMode.value;
})

const canReset = computed( () => {
  return userHasChanges(unref(initialUserData), unref(selectedUser)) || (hasUsers.value && isCreationMode.value);
})

const loadUsers = async () => {
  const {response, error} = await fetchUsers();

  if (error || !response) {
    onHandleFetchError(error);
    return;
  }

  users.value = response;
  selectedUser.value = selectUser(unref(users), getNumberItemFromStorage(USER_ID_STORAGE_KEY))
  initialUserData.value = copyObject(selectedUser.value);
  comboSelection.value = selectedUser.value
}

const validate = () => {
  userForm.value.validate();
}

const onHandleSetupEmptyUser = () => {
  isCreationMode.value = true;
  selectedUser.value = createEmptyUser();
  initialUserData.value = createEmptyUser();
  validate();
}

const updateUserInformation = async () => {
  const {error, response} = await createOrUpdateUser(unref(selectedUser), httpMethod.PUT);

  if (error || !response) {
    onHandleFetchError(error);
    return;
  }

  selectedUserId.value = response.id;
  saveItemToStorage(response.id, USER_ID_STORAGE_KEY);
  loadUsers();
}

const createNewUserInformation = async () => {
  const {error, response} = await createOrUpdateUser(unref(selectedUser), httpMethod.POST);

  if (error || !response) {
    onHandleFetchError(error);
    return;
  }

  isCreationMode.value = false;
  saveItemToStorage(response.id, USER_ID_STORAGE_KEY);
  loadUsers();
}

const onHandleCreateOrUpdateUser = async () => {
  selectedUser.value.id === 0
      ? await createNewUserInformation()
      : await updateUserInformation()
}

const onHandleResetUser = () => {
  isCreationMode.value = false;
  panelExpander.value = [1];
  loadUsers();
}

const onHandleSelectionChange = () => {
  const userId = comboSelection.value?.id;
  if(!userId) return;
  saveItemToStorage(userId, USER_ID_STORAGE_KEY);
}

watch(comboSelection, () => {
  if (comboSelection.value) {
    selectedUser.value = comboSelection.value;
    initialUserData.value = copyObject(selectedUser.value);
  }
});

onMounted(async () => {
  await loadUsers();

  if (props.startInCreationMode || !hasUsers.value) {
    onHandleSetupEmptyUser();
  }
});

return { __sfc: true,t, props, emits, comboSelection, users, userForm, selectedUserId, selectedUser, initialUserData, hasNoEditRights, isValid, addressValid, isCreationMode, panelExpander, canSave, onHandleFetchError, hasUsers, comboboxIsActive, canReset, loadUsers, validate, onHandleSetupEmptyUser, updateUserInformation, createNewUserInformation, onHandleCreateOrUpdateUser, onHandleResetUser, onHandleSelectionChange, FloatingActionButton, AddressEdit, firstNameLength, lastNameLength, mailLength, paycardNumberLength, phoneNumberLength, isBiggerOrEqualToMinLength, isRequired, isSmallerOrEqualToMaxLength, isValidEmail }
}

})